<div class="modal__content">
  <div id="button-group" class="button-group button-group--vertical button-group--blue">
    <p *ngIf="showNawWarning" id="modalHeading">{{ 'naw.reassign.warningDialog.description.singleExam' | translate}}</p>
    <div>
      <label id="assign-button" class="button button--icon-block btn-align u-m---" (click)="assignWorkItem()">
        <span>{{'assignToMe.label.assign' | translate}}</span>
      </label>
    </div>
    <div>
      <label id="assign-and-launch-button" class="button button--icon-block btn-align u-m---"
             (click)="assignAndLaunchViewer()">
        <span>{{ 'assignToMe.label.assignAndLaunch' | translate}}</span>
      </label>
    </div>
    <div>
      <label id="preview-button" class="button button--icon-block btn-align u-m---" (click)="previewWorkItem()">
        <span>{{ 'assignToMe.label.openPreviewMode' | translate}}</span>
      </label>
    </div>
  </div>
</div>
